module.exports = __webpack_public_path__ + "static/img/200129.5ea431a0.png";